var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.125,
    height: 23.125,
    viewBox: "0 0 23.125 23.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-alert",
    "data-name": "Icon ionic-ios-alert",
    d: "M14.938,3.375A11.562,11.562,0,1,0,26.5,14.938,11.561,11.561,0,0,0,14.938,3.375Zm.956,6.093-.172,6.4a.8.8,0,0,1-.784.823h0a.8.8,0,0,1-.784-.823l-.172-6.4a.957.957,0,0,1,.956-.978h0A.958.958,0,0,1,15.894,9.468Zm-.956,10.918A1.024,1.024,0,1,1,16,19.362,1.033,1.033,0,0,1,14.938,20.385Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#b2b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationWarning);
export default __webpack_public_path__ + "static/media/exclamation-warning.806aa61c56597d21b5164b349e98ff86.svg";
export { ForwardRef as ReactComponent };